import { render, staticRenderFns } from "./AlterarDadosPainel.vue?vue&type=template&id=dad0924a&scoped=true"
import script from "./AlterarDadosPainel.vue?vue&type=script&lang=js"
export * from "./AlterarDadosPainel.vue?vue&type=script&lang=js"
import style0 from "./AlterarDadosPainel.vue?vue&type=style&index=0&id=dad0924a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad0924a",
  null
  
)

export default component.exports